import { ImpactModule } from 'types'
import { PROCESSES_AND_DOCUMENTS_PAGES } from './pages'
import { PROCESSES_AND_DOCUMENTS_PAGES_ORDER_FOR_PERMISSIONS } from './pagesOrderForPermissions'

export const PROCESSES_AND_DOCUMENTS_MODULE: ImpactModule = {
  NAME: 'admin',
  NAME_PTBR: 'Processos e Documentos',
  UPPER_NAME: 'ADMIN',
  API_NAME: 'ADMIN',
  PAGES: PROCESSES_AND_DOCUMENTS_PAGES,
  PAGES_ORDER_FOR_PERMISSIONS: PROCESSES_AND_DOCUMENTS_PAGES_ORDER_FOR_PERMISSIONS,
}
